import { VerticalContainer } from '@american-autonomy/ag-ui';

import MapError from 'components/MapHorizontalControlBar/components/MapError';

import { TEST_ID, WARNING_ITEM_TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

// Reuses MapError's warning-banner visual (icon + message). Each warning string is
// wrapped in an Error instance because MapError consumes `error: Error`. This keeps
// the affordance identical to the page-level error banner already used in 2c-i.
const PlanWarnings: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, warnings }) => {
    if (warnings.length === 0) {
        return null;
    }

    return (
        <VerticalContainer className={`${className} ${styles.planWarnings}`} testId={testId}>
            {warnings.map((warning, index) => (
                <MapError
                    className={styles.warning}
                    error={new Error(warning)}
                    key={`${index}-${warning}`}
                    testId={`${WARNING_ITEM_TEST_ID}-${index}`}
                />
            ))}
        </VerticalContainer>
    );
};

export default PlanWarnings;
